export default __webpack_public_path__ + "static/media/fally.631d10a3.jpg";